/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * GTO Wizard API v4
 * API documentation for GTO Wizard frontend API
 * OpenAPI spec version: 4
 */
import { useMutation, useQuery } from '@tanstack/vue-query'
import type {
  DataTag,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query'

import { computed, unref } from 'vue'
import type { MaybeRef } from 'vue'

import type {
  AggregatedReportEmptyResponseSchema,
  AggregatedReportPreBuySchema,
  AggregatedReportPriceSchema,
  AggregatedReportRequestSchema,
  AggregatedReportResponseSchema,
  CustomAggregatedReportSchema,
  CustomTreeOrSolutionParamsRequest,
  EditCustomAggregatedReportSchema,
  GetAggregatedReportParams,
  GetCustomReportHistoryParams,
  GetReportStatusParams,
  PagedCustomAggregatedReportSchema,
} from '../models'

import getAggregatedReportMutator from '../../../client'
import getReportStatusMutator from '../../../client'
import getReportPriceMutator from '../../../client'
import updateCustomAggregatedReportMutator from '../../../client'
import getCustomReportHistoryMutator from '../../../client'

type AwaitedInput<T> = PromiseLike<T> | T

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never

/**
 * Gets Aggregated Report by Custom Tree ID
 * @summary Get Aggregated Report
 */
export const getAggregatedReport = (
  aggregatedReportRequestSchema: MaybeRef<AggregatedReportRequestSchema>,
  params?: MaybeRef<GetAggregatedReportParams>,
  signal?: AbortSignal,
) => {
  aggregatedReportRequestSchema = unref(aggregatedReportRequestSchema)
  params = unref(params)

  return getAggregatedReportMutator<
    AggregatedReportResponseSchema | void | AggregatedReportEmptyResponseSchema
  >({
    url: `/v4/aggregated-report/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: aggregatedReportRequestSchema,
    params: unref(params),
    signal,
  })
}

export const getGetAggregatedReportMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAggregatedReport>>,
    TError,
    { data: AggregatedReportRequestSchema; params?: GetAggregatedReportParams },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof getAggregatedReport>>,
  TError,
  { data: AggregatedReportRequestSchema; params?: GetAggregatedReportParams },
  TContext
> => {
  const mutationKey = ['getAggregatedReport']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getAggregatedReport>>,
    { data: AggregatedReportRequestSchema; params?: GetAggregatedReportParams }
  > = props => {
    const { data, params } = props ?? {}

    return getAggregatedReport(data, params)
  }

  return { mutationFn, ...mutationOptions }
}

export type GetAggregatedReportMutationResult = NonNullable<
  Awaited<ReturnType<typeof getAggregatedReport>>
>
export type GetAggregatedReportMutationBody = AggregatedReportRequestSchema
export type GetAggregatedReportMutationError = unknown

/**
 * @summary Get Aggregated Report
 */
export const useGetAggregatedReport = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAggregatedReport>>,
    TError,
    { data: AggregatedReportRequestSchema; params?: GetAggregatedReportParams },
    TContext
  >
}): UseMutationReturnType<
  Awaited<ReturnType<typeof getAggregatedReport>>,
  TError,
  { data: AggregatedReportRequestSchema; params?: GetAggregatedReportParams },
  TContext
> => {
  const mutationOptions = getGetAggregatedReportMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * @summary Get Report Status
 */
export const getReportStatus = (
  customTreeId: MaybeRef<string>,
  params?: MaybeRef<GetReportStatusParams>,
  signal?: AbortSignal,
) => {
  customTreeId = unref(customTreeId)
  params = unref(params)

  return getReportStatusMutator<AggregatedReportPreBuySchema>({
    url: `/v4/aggregated-report/${customTreeId}/`,
    method: 'GET',
    params: unref(params),
    signal,
  })
}

export const getGetReportStatusQueryKey = (
  customTreeId: MaybeRef<string>,
  params?: MaybeRef<GetReportStatusParams>,
) => {
  return ['v4', 'aggregated-report', customTreeId, ...(params ? [params] : [])] as const
}

export const getGetReportStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getReportStatus>>,
  TError = unknown,
>(
  customTreeId: MaybeRef<string>,
  params?: MaybeRef<GetReportStatusParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportStatus>>, TError, TData>>
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = getGetReportStatusQueryKey(customTreeId, params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportStatus>>> = ({ signal }) =>
    getReportStatus(customTreeId, params, signal)

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(customTreeId)),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getReportStatus>>, TError, TData>
}

export type GetReportStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getReportStatus>>>
export type GetReportStatusQueryError = unknown

/**
 * @summary Get Report Status
 */

export function useGetReportStatus<
  TData = Awaited<ReturnType<typeof getReportStatus>>,
  TError = unknown,
>(
  customTreeId: MaybeRef<string>,
  params?: MaybeRef<GetReportStatusParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportStatus>>, TError, TData>>
  },
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetReportStatusQueryOptions(customTreeId, params, options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>

  return query
}

/**
 * @summary Get Report Price
 */
export const getReportPrice = (
  customTreeOrSolutionParamsRequest: MaybeRef<CustomTreeOrSolutionParamsRequest>,
  signal?: AbortSignal,
) => {
  customTreeOrSolutionParamsRequest = unref(customTreeOrSolutionParamsRequest)

  return getReportPriceMutator<AggregatedReportPriceSchema>({
    url: `/v4/aggregated-report/price/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: customTreeOrSolutionParamsRequest,
    signal,
  })
}

export const getGetReportPriceMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getReportPrice>>,
    TError,
    { data: CustomTreeOrSolutionParamsRequest },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof getReportPrice>>,
  TError,
  { data: CustomTreeOrSolutionParamsRequest },
  TContext
> => {
  const mutationKey = ['getReportPrice']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getReportPrice>>,
    { data: CustomTreeOrSolutionParamsRequest }
  > = props => {
    const { data } = props ?? {}

    return getReportPrice(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type GetReportPriceMutationResult = NonNullable<Awaited<ReturnType<typeof getReportPrice>>>
export type GetReportPriceMutationBody = CustomTreeOrSolutionParamsRequest
export type GetReportPriceMutationError = unknown

/**
 * @summary Get Report Price
 */
export const useGetReportPrice = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getReportPrice>>,
    TError,
    { data: CustomTreeOrSolutionParamsRequest },
    TContext
  >
}): UseMutationReturnType<
  Awaited<ReturnType<typeof getReportPrice>>,
  TError,
  { data: CustomTreeOrSolutionParamsRequest },
  TContext
> => {
  const mutationOptions = getGetReportPriceMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * @summary Update Custom Aggregated Report
 */
export const updateCustomAggregatedReport = (
  customReportId: MaybeRef<string>,
  editCustomAggregatedReportSchema: MaybeRef<EditCustomAggregatedReportSchema>,
) => {
  customReportId = unref(customReportId)
  editCustomAggregatedReportSchema = unref(editCustomAggregatedReportSchema)

  return updateCustomAggregatedReportMutator<CustomAggregatedReportSchema>({
    url: `/v4/aggregated-report/custom-report/${customReportId}/`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: editCustomAggregatedReportSchema,
  })
}

export const getUpdateCustomAggregatedReportMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCustomAggregatedReport>>,
    TError,
    { customReportId: string; data: EditCustomAggregatedReportSchema },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCustomAggregatedReport>>,
  TError,
  { customReportId: string; data: EditCustomAggregatedReportSchema },
  TContext
> => {
  const mutationKey = ['updateCustomAggregatedReport']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCustomAggregatedReport>>,
    { customReportId: string; data: EditCustomAggregatedReportSchema }
  > = props => {
    const { customReportId, data } = props ?? {}

    return updateCustomAggregatedReport(customReportId, data)
  }

  return { mutationFn, ...mutationOptions }
}

export type UpdateCustomAggregatedReportMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCustomAggregatedReport>>
>
export type UpdateCustomAggregatedReportMutationBody = EditCustomAggregatedReportSchema
export type UpdateCustomAggregatedReportMutationError = unknown

/**
 * @summary Update Custom Aggregated Report
 */
export const useUpdateCustomAggregatedReport = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCustomAggregatedReport>>,
    TError,
    { customReportId: string; data: EditCustomAggregatedReportSchema },
    TContext
  >
}): UseMutationReturnType<
  Awaited<ReturnType<typeof updateCustomAggregatedReport>>,
  TError,
  { customReportId: string; data: EditCustomAggregatedReportSchema },
  TContext
> => {
  const mutationOptions = getUpdateCustomAggregatedReportMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * @summary Get Custom Report History
 */
export const getCustomReportHistory = (
  params?: MaybeRef<GetCustomReportHistoryParams>,
  signal?: AbortSignal,
) => {
  params = unref(params)

  return getCustomReportHistoryMutator<PagedCustomAggregatedReportSchema>({
    url: `/v4/aggregated-report/custom/history/`,
    method: 'GET',
    params: unref(params),
    signal,
  })
}

export const getGetCustomReportHistoryQueryKey = (
  params?: MaybeRef<GetCustomReportHistoryParams>,
) => {
  return ['v4', 'aggregated-report', 'custom', 'history', ...(params ? [params] : [])] as const
}

export const getGetCustomReportHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomReportHistory>>,
  TError = unknown,
>(
  params?: MaybeRef<GetCustomReportHistoryParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomReportHistory>>, TError, TData>
    >
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = getGetCustomReportHistoryQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomReportHistory>>> = ({ signal }) =>
    getCustomReportHistory(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomReportHistory>>,
    TError,
    TData
  >
}

export type GetCustomReportHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomReportHistory>>
>
export type GetCustomReportHistoryQueryError = unknown

/**
 * @summary Get Custom Report History
 */

export function useGetCustomReportHistory<
  TData = Awaited<ReturnType<typeof getCustomReportHistory>>,
  TError = unknown,
>(
  params?: MaybeRef<GetCustomReportHistoryParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomReportHistory>>, TError, TData>
    >
  },
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCustomReportHistoryQueryOptions(params, options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>

  return query
}
